// JsFromRoutes CacheKey fc642ba97827186c9ad48589203f55ed
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  builder: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/:comp_id/builder'),
  create: /* #__PURE__ */ definePathHelper('post', '(/:locale)/comps'),
  new: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '(/:locale)/comps/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '(/:locale)/comps/:id'),
}
